import { render, staticRenderFns } from "./eDetail.vue?vue&type=template&id=9364a4a4&scoped=true&"
import script from "./eDetail.vue?vue&type=script&lang=js&"
export * from "./eDetail.vue?vue&type=script&lang=js&"
import style0 from "./eDetail.vue?vue&type=style&index=0&id=9364a4a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9364a4a4",
  null
  
)

/* custom blocks */
import block0 from "./eDetail.vue?vue&type=custom&index=0&blockType=noscript"
if (typeof block0 === 'function') block0(component)

export default component.exports